import React, { createContext, useContext } from "react";

const PartnerBillingContext = createContext(null);

export function PartnerBillingProvider({ children, value }) {
  return <PartnerBillingContext.Provider value={value}>{children}</PartnerBillingContext.Provider>;
}

export function usePartnerBilling() {
  const ctx = useContext(PartnerBillingContext);
  return ctx ?? { reseller: null, capabilities: null };
}
